import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, ReplaySubject } from 'rxjs';

import { MtnaLogger } from '@mtna/lib-ui';

import { RdsApiService } from './rds-api.service';

@Injectable({
  providedIn: 'root',
})
export class RdsServerService {
  /** base url for the service */
  protected get SERVER_URL(): string {
    return `${this.apiService.getApiUrl()}/server`;
  }

  protected _disclaimerCache$ = new ReplaySubject<string>(1);
  protected _disclaimerRequest$: Observable<string>;

  constructor(protected apiService: RdsApiService, protected http: HttpClient, protected logger: MtnaLogger) {}

  /**
   * Get the disclaimer (EULA) to display to users who want to use the RDS API.
   * If there is no EULA in effect, the response will be null.
   * @remarks This method uses caching, returns a hot observable.
   * @param refresh forces a cache refresh, will update all subscribers. Defaults to false.
   * @returns the EULA or null if not applicable
   */
  getDisclaimer(refresh: boolean = false): Observable<string> {
    if (refresh || !this._disclaimerRequest$) {
      this.logger.debug(`[RdsServerService] getDisclaimer - Fetching, ${refresh ? 'forced refresh' : 'not in cache'}`);
      this._disclaimerRequest$ = this.http.get<string>(`${this.SERVER_URL}/disclaimer`);
      this._disclaimerRequest$.subscribe(
        (result) => this._disclaimerCache$.next(result),
        (err) => this._disclaimerCache$.error(err)
      );
    }
    return this._disclaimerCache$.asObservable();
  }
}
